import {NgModule} from "@angular/core";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {CerbaAuthService, httpFactory} from "@digicerba/common";
import {
  HttpClient,
  IAlerteWebServiceClient,
  IAuditWebServiceClient,
  ICorrespondantWebServiceClient,
  IDebounceServiceClient,
  IDossierWebServiceClient,
  IEmissionWebServiceClient,
  ILaboratoireWebServiceClient,
  INotificationsCommonWebServiceClient,
  IUserInformationsWebServiceClient,
  IUtilisateurPreferencesWebServiceClient,
  IConfigWebServiceClient
} from "@resources/resources";
import {IInstanceModeleFormulaireWebServiceClient} from "@resources/resources.external";

import {ResourcesClient} from "./resources.client";
import { CORRESPONDANT_CLIENT, USER_INFO_CLIENT } from "@digicerba/common/resources/tokens/injectionTokens";

var resources: Array<any> = [
  /** Liste des resources du fichier resources.ts*/
  ICorrespondantWebServiceClient,
  IAuditWebServiceClient,
  IDossierWebServiceClient,
  ILaboratoireWebServiceClient,
  IUtilisateurPreferencesWebServiceClient,
  IEmissionWebServiceClient,
  IUserInformationsWebServiceClient,
  INotificationsCommonWebServiceClient,
  IAlerteWebServiceClient,
  CerbaAuthService,
  IDebounceServiceClient,
  IConfigWebServiceClient,
  IInstanceModeleFormulaireWebServiceClient,
  { provide : CORRESPONDANT_CLIENT, useClass : ICorrespondantWebServiceClient},
  { provide : USER_INFO_CLIENT, useClass : IUserInformationsWebServiceClient}

];

@NgModule({
  providers: [...resources, {
    provide: Http,
    useFactory: httpFactory,
    deps: [XHRBackend, RequestOptions, CerbaAuthService]
  },
    {provide: HttpClient, useClass: ResourcesClient}]
})
export class ResourcesModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/resources/resources.module.ts